import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=3599e754&scoped=true&"
import script from "./event-card.vue?vue&type=script&lang=js&"
export * from "./event-card.vue?vue&type=script&lang=js&"
import style0 from "./event-card.vue?vue&type=style&index=0&id=3599e754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3599e754",
  null
  
)

export default component.exports